import Dam from "./components/dam/dam"
import Line from "./components/line/line"
import Path from "./components/path/path"
import TankDam from "./components/tank_dam/tank_dam"
import store from "../../store/store"

export default function Canvas(opts={}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let lines = opts.lines || []
    let paths = {}

    this.generate = () =>{
        lines.forEach(line=>{
            let _obj = undefined
            if(line.type === 'line'){
                _obj = new Line({container:container, options:line})
                _obj.generate()
                
            } else if(line.type === 'path'){
                _obj = new Path({container:container, options:line})
                _obj.generate()
            } else if(line.type === 'dam'){
                if(line.dam_type === 'res'){
                    _obj = new TankDam({container:container, options:line})
                    _obj.generate()
                } else {
                    _obj = new Dam({container:container, options:line})
                    _obj.generate()
                }
            }

            if(_obj){
                paths[line.id] = _obj
            }
        })

        $('.canvas-container')[0].addEventListener('scroll', function(event) { store.diagramStore.pathUpdatePosition() })
    }

    this.getPath = (path_id) =>{
        $.each(paths, (id, path)=>{
            if(id == path_id){
                return path
            }  
        })
    }
}

Canvas.prototype = Object.create(BaseConstructor.prototype)